var server_API = "https://test.northstarz.ai";
var local_API = "http://localhost:8989";
var server_django_api = "https://122.176.112.216/django";
var hosted_api = "https://northstarz.ai";
var django_hosted_api = "https://interviewguru.co/django";
var b2b_server_api = "https://test.talent.northstarz.ai";
var b2b_server_hosted_api = "https://northstarz.ai";
var local_socket_api = "wss://test.northstarz.ai/api/ws";
var server_socket_api = "wss://northstarz.ai/api/ws";

if (
  !(
    window.location.href.includes("localhost") ||
    window.location.href.includes("122.176.112.216") ||
    window.location.href.includes("test-ats.northstarz.ai") ||
    window.location.href.includes("test.northstarz.ai") ||
    window.location.href.includes("test.northstarz.ai")
  )
) {
  server_API = hosted_api;
  server_django_api = django_hosted_api;
  b2b_server_api = b2b_server_hosted_api;
  local_socket_api = server_socket_api;
}

const data1 = {
  API: "interviewvision.com",
};

if (window.location.href.includes("localhost")) {
  server_API = local_API;
}

export { server_API, local_API, server_django_api, b2b_server_api, data1, local_socket_api };

export const baseURL = "https://northstarz.ai/";
